import { useRef, memo } from 'react'
import { useDrag, useDrop } from 'react-dnd'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import Box from '@mui/material/Box'
import { ReactComponent as IconDragHandle } from '../icons/DragHandle.svg'
import { Draggable } from 'react-beautiful-dnd'

const ListItem = ({ 
  text, 
  index, 
  draggableIndex,
}) => {

    return (
      <Draggable draggableId={draggableIndex} index={index}>
        {(provided) => (
          <div
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            ref={provided.innerRef}
          >
            <Box
              sx={(theme) => ({
                pr: 1.5,
                pl: 4,
                py: 1,
                my: 1,
                borderWidth: 1,
                borderStyle: "solid",
                borderColor: theme.palette.neutral.light,
                borderRadius: "8px",
                cursor: "grab",
                position: "relative",
                bgcolor: theme.palette.neutral.lightest,
                // opacity: isDragging ? 0 : 1,
              })}
            >
              <Box
                sx={{
                  position: "absolute",
                  top: -2,
                  left: -2,
                  height: "calc(100% + 4px)",
                  width: 30,
                  borderTopLeftRadius: "8px",
                  borderBottomLeftRadius: "8px",
                  bgcolor: "secondary.main",
                  display: "inline-grid",
                  placeItems: "center",
                  placeContent: "center",
                }}
              >
                <IconDragHandle />
              </Box>
              {text}
            </Box>
          </div>
        )}
      </Draggable>
    )
}

export default memo(ListItem)